// extracted by mini-css-extract-plugin
export var link = "_vm-0";